// @flow
'use strict';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';

import FormExportacaoNfce from './form_exportacao_nfce';
import { onSubmitForm } from '../functions';

import { rootSelector } from '../../../../../../reducers/lista_documentos/nfce';
import { openModalSelector } from '../../../../../../reducers/modal_exportacao_lista';

export default compose(
    connect<*, *, *, *, *, *>(createStructuredSelector({
      open: openModalSelector,
      initialValues: rootSelector,
    })),
    reduxForm({
      form: 'listaDocumentosNfce', enableReinitialize: true,
      onSubmit: onSubmitForm,
    }),
)(FormExportacaoNfce);